// scroll functions and listeners

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
import * as Resize from './4-resize.js';

// exported variables ---------------------------------------------------------
export let scrollTop = 0;
export let scrollLeft = 0;
export let windowBottom = window.innerHeight;
export let windowRight = window.innerWidth;

export let atBodyBottom = false;
export let atBodyRight = false;
export let isScrolling = false;

// for hiding sticky
export let prevScrollTop = 0;
export let stickyTimeout;
export let scrolledHeader = false;

// local variables ------------------------------------------------------------
let scrollDuration = 35; // default = 35
let prevSection = -2; // previous section index, used to prevent unnecessary updates
const cardsSliderEls = document.querySelectorAll('.cards__slider');
const footerMEl = document.querySelector('.footer__m');
const jumbotronEl = document.querySelector('.jumbotron');

// crossfading bg elements, to avoid a background-color transition flash on retina chrome
const bgEls = [document.querySelector('.bg--1'), document.querySelector('.bg--2')];
let activeBgIndex = 0; // index in bgEls of the currently visible element
export let activeBgEl = bgEls[activeBgIndex];

export const setPrevSection = (section) => {
  // set the previous section index
  prevSection = section;
}

// scroll listeners ------------------------------------------------------------
export const initScroll = () => {
  // scroll listener
  window.addEventListener('scroll', setScroll, {passive: true});

  // prevent flickering on scroll
  document.body.addEventListener('wheel', event => {
    if (isScrolling) {
      event.preventDefault();
      event.stopPropagation();
    }
  });

  document.body.addEventListener('touchmove', event => {
    if (isScrolling) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {passive: false}); // Changed to passive: false to allow preventDefault

};

// scroll function ------------------------------------------------------------
export const setScroll = () => {
  // do scrolling actions
  // console.log('setScroll');

  // if ('fixer' in Once && typeof Once.fixer?.bodyFixed !== 'undefined') {
  //   if (Once.fixer.bodyFixed !== true) {
  //     updateFromScroll();
  //   }
  // } else {
  //   updateFromScroll();
  // }

  updateFromScroll();

};

const updateFromScroll = () => {
  scrollTop = window.scrollY || document.documentElement.scrollTop;
  scrollLeft = window.scrollX || document.documentElement.scrollLeft;

  windowBottom = scrollTop + window.innerHeight;
  windowRight = scrollLeft + window.innerWidth;

  // use >= becaues of ios scrolling past the max, -1 for smooth scroll
  atBodyBottom = scrollTop >= Resize.maxBodyScrollTop - 1;
  atBodyRight = scrollLeft >= Resize.maxBodyScrollLeft - 1;

  // console.log('updateFromScroll', {scrollTop, scrollLeft, windowBottom, windowRight, atBodyBottom, atBodyRight});

  // colors -----------------------------------------------------
  let section = 0;
  const sectionEls = document.querySelectorAll('.section');
  sectionEls.forEach((sectionEl, index) => {
    const rect = sectionEl.getBoundingClientRect();
    const sectionTop = rect.top;

    let switchPosition;
    if (sectionEl.classList.contains('section--footer') && Vars.mqPortrait.matches) {
      switchPosition = Resize.windowHeight / 4 * 3;
    } else if (['shows', 'productions', 'productions-archive'].includes($pageType) ) {
      switchPosition = 50;
    } else  {
      switchPosition = Resize.windowHeight / 2;
    }

    // if the next section is 50% in view, use that section
    if (sectionTop < switchPosition) section = index;
  });

  if (jumbotronEl) {
    const rect = jumbotronEl.getBoundingClientRect();
    // console.log('jumbotron', rect.bottom);
    if (rect.bottom > 50) section = 0; // if at the top, use first section
  }

  if (Resize.introTextEl && Resize.introEl && Resize.introMEl) {
    const textRect = Resize.introTextEl.getBoundingClientRect();
    const introRect = Resize.introEl.getBoundingClientRect();
    // console.log('introText', textRect.top, introRect.bottom);
    if (textRect.top < Resize.windowHeight / 4 * 2 && introRect.bottom > Resize.windowHeight / 2) {
      section = -1; // intro text section
      Resize.introMEl.classList.remove('m--light');
    } else {
      Resize.introMEl.classList.add('m--light');
    }
  }

  if (section !== prevSection) setColors(section);
  prevSection = section;

  // intro m -------------------------------------------------------------
  if (Resize.introMEl && Resize.introEl) {
    const rect = Resize.introEl.getBoundingClientRect();
    if (rect.top < Resize.windowHeight / 2 && rect.bottom > Resize.windowHeight / 2){
      Resize.introMEl.classList.add('intro__m--active');
    } else {
      Resize.introMEl.classList.remove('intro__m--active');
    }
  }

  // footer m ----------------------------------------------
  if (footerMEl) {
    const rect = footerMEl.getBoundingClientRect();
    if (rect.top < Resize.windowHeight / 2 || (Vars.mqPortrait.matches && rect.top < Resize.windowHeight * .75)) {
      footerMEl.setAttribute('class', 'footer__m m m--bold');
    } else {
      footerMEl.setAttribute('class', 'footer__m m m--thin');
    }
  }

  // cards animation ------------------------------------------------
  cardsSliderEls.forEach(cardsSliderEl => {
    const rect = cardsSliderEl.getBoundingClientRect();
    if (rect.top < Resize.windowHeight / 3 * 2) {
      cardsSliderEl.classList.add('cards__slider--ordered');
    } else {
      cardsSliderEl.classList.remove('cards__slider--ordered');
    }
  });

  // intro scroll sickness -----------------------------------------------------
  const holderEls = document.querySelectorAll('.intro');
  holderEls.forEach(holderEl => {
    const itemHolderEls = holderEl.querySelectorAll('.intro__holder');
    itemHolderEls.forEach(itemHolderEl => {
      const itemEl = itemHolderEl.querySelector('video, img');
      if (!itemEl) return;

      // if (Vars.blTouch) {
      if (false) {
        itemEl.style.transform = '';
      } else {
        const rect = itemHolderEl.getBoundingClientRect();
        const itemCenter = rect.top + (rect.height / 2);
        const windowCenter = window.innerHeight / 2;

        // console.log({itemCenter, windowCenter});
        const dist = itemCenter - windowCenter;
        let multiplier = 0.5 + Number(itemHolderEl.dataset.random);
        if (Vars.blTouch) multiplier *= 0.6; // touch devices are more sensitive
        // let offset = dist * dist * dist / 200000 * multiplier;
        let offset = dist * multiplier;
        // if (dist < 0) offset = -offset;
        // const offset = dist / 2 * multiplier;

        // console.log({dist, multiplier, offset});
        // transform
        itemEl.style.transform = `translateY(${offset}px)`;
      }
    });
  });

  // sticky scroll -------------------------------------------------------------
  if (scrollTop > Resize.stickyHeight) {
    document.body.classList.add('body--scrolled-sticky');
  
    if (!scrolledHeader) {
      document.body.classList.add('body--sticky-hidden');
      scrolledHeader = true;
    }
  } else {
    document.body.classList.remove('body--scrolled-sticky');
    scrolledHeader = false;
  }
  
  const scrollDiff = scrollTop - prevScrollTop;

  // needs to be > 8 for iOS bugs
  if (scrollDiff > 8) { // scroll down fast
    document.body.classList.add('body--sticky-hidden');
  } else if (scrollDiff < -8) { // scroll up fast
    document.body.classList.remove('body--sticky-hidden');
  
    clearTimeout(stickyTimeout);
    stickyTimeout = setTimeout(checkHideSticky, Vars.transitionSlow * 4);
  }
  
  prevScrollTop = scrollTop;
  
  // switch ($pageType) {
  //
  // }
};

// functions -------------------------------------------------------------------
// hiding sticky
export const checkHideSticky = () => {
  const focusedEl = document.activeElement;
  if (focusedEl && (focusedEl.matches(Resize.stickySelector) || focusedEl.closest(Resize.stickySelector))) return;

  document.body.classList.add('body--sticky-hidden');

  const filtersEl = document.querySelector('.filters');
  if (filtersEl && document.body.classList.contains('body--scrolled-sticky')) filtersEl.classList.remove('filters--active');
};

export const setColors = (sectionNr = prevSection) => {
  // console.log('setColors', sectionNr);
  let colorEl;
  const blNav = document.body.classList.contains('body--nav');

  // wait for a running bg transition; only the latest call is remembered
  if (bgBusy && !blNav) {
    pendingSection = sectionNr;
    return;
  }

  // console.log('now setting colors for section', sectionNr);

  if (sectionNr === -1) {
    colorEl = Resize.introTextEl; // intro text section
  } else if (blNav) {
    colorEl = document.querySelector('.nav'); // for logo and menu btn
  } else {
    colorEl = document.querySelectorAll('.section')[sectionNr];
  }

  if (colorEl) {
    const color = colorEl.dataset.color;
    const bg = colorEl.dataset.bg;

    document.documentElement.style.setProperty('--color', color);
    if (!blNav) {
      document.documentElement.style.setProperty('--bg-color', bg);
      crossfadeBg(bg);
    }

    // console.log('setColors', {sectionNr}, {color: colorEl.dataset.color}, {bg: colorEl.dataset.bg});

    const whites = ['white', '#ffffff', '#fff', '#FFFFFF', '#FFF'];

    const mainEl = document.querySelector('.main');
    if (mainEl) {
      if ((whites.includes(color) || whites.includes(bg))
          && !colorEl.querySelector('.jumbotron')
          && !document.body.classList.contains('body--nav')) {
        mainEl.classList.add('main--on-white');
      }  else {
        mainEl.classList.remove('main--on-white');
      }
    }
  }
}
// crossfade the two .bg elements instead of transitioning background-color, to avoid a flash
let bgBusy = false;
let pendingSection = null; // only the latest queued section is kept
const crossfadeBg = (bg) => {
  const [bgEl, bg2El] = bgEls;
  if (!bgEl || !bg2El) return;

  const currentEl = bgEls[activeBgIndex];
  if (currentEl.style.backgroundColor === bg) return; // already showing this color

  const nextIndex = activeBgIndex ? 0 : 1;
  const nextEl = bgEls[nextIndex];

  nextEl.style.backgroundColor = bg;
  nextEl.style.opacity = 1;
  currentEl.style.opacity = 0;

  activeBgIndex = nextIndex;
  activeBgEl = nextEl;

  bgBusy = true;
  setTimeout(() => {
    bgBusy = false;
    if (pendingSection !== null) {
      const next = pendingSection;
      pendingSection = null;
      setColors(next);
    }
  }, Vars.transitionSlow);
};

export const checkBlockScroll = () => {
  // console.log('checkBlockScroll');
  const hasFixer = 'fixer' in Once && typeof Once.fixer?.bodyFixed !== 'undefined';
  const hasAnimator = 'animator' in Once && typeof Once.animator?.disableSmoothScroll !== 'undefined';
  if (document.querySelector('.popover--active, .body--nav, .media--fullscreen')) {
    if (hasFixer) Once.fixer.fixBody();
    if (hasAnimator) Once.animator.disableSmoothScroll();
  } else {
    if (hasFixer) Once.fixer.unfixBody();
    if (hasAnimator && !isScrolling) Once.animator.enableSmoothScroll();
    if ('saveOffsets' in Resize) Resize.saveOffsets();
  }
};

export const scrollToEl = (el, returnFunction = '', offset = Resize.headerHeight) => {
  const rect = el.getBoundingClientRect();
  const top = rect.top + scrollTop - offset;
  animateScrollTop(top, document.body, returnFunction);
};

export const animateScrollTop = (
  scroll,
  element = document.body,
  returnFunction = '',
  useMax = true,
) => {
  // console.log('animateScrollTop', {scroll}, {element}, {returnFunction}, {useMax});

  let height;
  let scrollHeight;
  if (element.tagName === 'BODY') {
    height = window.innerHeight;
    scrollHeight = document.documentElement.scrollHeight;

    if ('animator' in Once) Once.animator.disableSmoothScroll();
  } else {
    // not body
    height = element.offsetHeight;
    scrollHeight = element.scrollHeight;
  }

  if (useMax) {
    // maxscroll is where the scroll reaches the bottom
    // don't go past that or the animation will not be smooth
    const maxScroll = scrollHeight - height;
    if (scroll > maxScroll) scroll = maxScroll;
    if (scroll < 0) scroll = 0;
  }

  // needs to change for body because of browser differences
  if (element.tagName === 'BODY') element = document.documentElement;

  // console.log({height}, {scroll});

  scrollToPosition(scroll, 'top', element, returnFunction);
};

export const animateScrollLeft = (
  scroll,
  element = document.body,
  returnFunction = '',
  useMax = true,
) => {
  // console.log('animateScrollLeft', {scroll}, {element}, {returnFunction}, {useMax});

  let width;
  let scrollWidth;
  if (element.tagName === 'BODY') {
    width = window.innerWidth;
    scrollWidth = document.documentElement.scrollWidth;
  } else {
    // not body
    width = element.offsetWidth;
    scrollWidth = element.scrollWidth;
  }

  if (useMax) {
    // maxscroll is where the scroll reaches the side
    const maxScroll = scrollWidth - width;
    if (scroll > maxScroll) scroll = maxScroll;
    if (scroll < 0) scroll = 0;
  }

  // needs to change for body because of browser differences
  if (element.tagName === 'BODY') element = document.documentElement;

  // console.log({width}, {scroll});

  scrollToPosition(scroll, 'left', element, returnFunction);
};

const scrollToPosition = (to, direction = 'top', element, returnFunction = '') => {
  // get document scroll
  let start;
  if (element == document.documentElement) {
    start = direction === 'top' ? window.scrollY || element.scrollTop : window.scrollX || element.scrollLeft;
  } else {
    start = direction === 'top' ? element.scrollTop : element.scrollLeft;
  }

  const change = to - start;
  if (change < 1 && change > -1) {
    if (element == document.documentElement) checkBlockScroll();
    if (typeof returnFunction === 'function') returnFunction();
    return;
  }

  isScrolling = true;
  let duration = Math.sqrt(Math.abs(change)) * scrollDuration;
  if (duration < Vars.transitionDefault) duration = Vars.transitionDefault;
  const increment = 15;
  let currentTime = 0;
  // console.log(element.tagName, {start, change, duration, increment, currentTime});

  const easeInOutQuart = t => (t < 0.5) ? (8 * (t ** 4)) : (1 - (8 * ((--t) * (t ** 3))));

  const animateScroll = () => {
    currentTime += increment;
    const val = easeInOutQuart(currentTime / duration);
    const currentScroll = start + (change * val);
    if (direction === 'top') {
      element.scrollTo({top: currentScroll});
    } else {
      element.scrollTo({left: currentScroll});
    }

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    } else {
      isScrolling = false;
      if (element == document.documentElement) checkBlockScroll();
      if (typeof returnFunction === 'function') returnFunction();
    }
  };

  animateScroll();
};
